import {makeAutoObservable} from 'mobx'
import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {useEffect} from 'react'
import {cn} from '@containers/html-utils'
import {UIElement} from '../model/ui-element'
import {ApiElement} from './api-element'

export interface ApiBoardSettingsParams {
  id: string
  element: UIElement
}

const refEl: {[key: string]: UIElement} = {}

export const ApiBoardSettingsCtl = {
  setEl: (params: ApiBoardSettingsParams) => {
    const {id, element} = params
    refEl[id] = element
    uiStore.updateModified()
  }
}

export const ApiBoardSettings = observer(({id}: {id: string}) => {
  useEffect(() => {
    //
  }, [uiStore.state.modified])

  const element = refEl[id]

  if (!element) {
    return null
  }

  return (
    <div className={cn('api-board-settings', id)}>
      <ApiElement element={element} />
    </div>
  )
})

///

class UIStore {
  state: {modified: number} = {
    modified: 0
  }

  constructor() {
    makeAutoObservable(this, {}, {autoBind: true})
  }

  updateModified(): void {
    this.state.modified = Date.now()
  }
}

const uiStore = new UIStore()
